import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

// Connects to data-controller="admin-donut-chart"
export default class extends Controller {
  static targets = ["chart", "periodSelect", "legendItem"]
  static values = {
    series: Array,
    labels: Array,
    colors: Array,
    width: { type: Number, default: 380 },
    donutSize: { type: String, default: "65%" }
  }

  connect() {
    this.initChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  initChart() {
    const options = this.buildOptions()
    this.chart = new ApexCharts(this.chartTarget, options)
    this.chart.render()
  }

  buildOptions() {
    return {
      series: this.seriesValue,
      chart: {
        type: "donut",
        width: this.widthValue,
        fontFamily: "Satoshi, sans-serif"
      },
      colors: this.colorsValue,
      labels: this.labelsValue,
      legend: {
        show: false,
        position: "bottom"
      },
      plotOptions: {
        pie: {
          donut: {
            size: this.donutSizeValue,
            background: "transparent"
          }
        }
      },
      stroke: {
        width: 0
      },
      dataLabels: {
        enabled: false
      },
      responsive: [
        {
          breakpoint: 640,
          options: {
            chart: {
              width: 200
            }
          }
        }
      ]
    }
  }

  selectPeriod(event) {
    const select = event.currentTarget
    const period = select.value

    // Dispatch custom event for period change
    this.dispatch("periodChange", { detail: { period } })
  }

  // Public method to update chart data
  updateSeries(newSeries) {
    if (this.chart) {
      this.chart.updateSeries(newSeries)
    }
  }

  // Public method to update labels
  updateLabels(newLabels) {
    if (this.chart) {
      this.chart.updateOptions({
        labels: newLabels
      })
    }
  }

  // Public method to update both series and labels
  updateData(newSeries, newLabels) {
    if (this.chart) {
      this.chart.updateOptions({
        series: newSeries,
        labels: newLabels
      })
    }
  }

  // Public method to update colors
  updateColors(newColors) {
    if (this.chart) {
      this.chart.updateOptions({
        colors: newColors
      })
    }
  }

  // Public method to update chart options
  updateOptions(newOptions) {
    if (this.chart) {
      this.chart.updateOptions(newOptions)
    }
  }

  // Public method to toggle data point visibility
  toggleDataPointIndex(index) {
    if (this.chart) {
      this.chart.toggleDataPointSelection(index)
    }
  }

  // Toggle legend item visibility (called from click on custom legend)
  toggleLegendItem(event) {
    const button = event.currentTarget
    const seriesIndex = parseInt(button.dataset.seriesIndex, 10)
    
    if (this.chart && !isNaN(seriesIndex)) {
      this.chart.toggleSeries(this.labelsValue[seriesIndex])
      
      // Toggle visual state of the legend item
      button.classList.toggle('opacity-50')
    }
  }
}
